/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CaseTypesService {
    /**
     * List all case types
     * Get a paginated list of case types for the authenticated user
     * @param parentId Filter by parent case type ID
     * @param isActive Filter by active status
     * @param search Search by case type name
     * @returns any List of case types
     * @throws ApiError
     */
    public static f8Bba1D05Cbe34A2790612Fb2884D(
        parentId?: number,
        isActive?: 'Yes' | 'No',
        search?: string,
    ): CancelablePromise<{
        success?: boolean;
        data?: Record<string, any>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/case-types',
            query: {
                'parent_id': parentId,
                'is_active': isActive,
                'search': search,
            },
            errors: {
                401: `Unauthenticated`,
            },
        });
    }
    /**
     * Create a new case type
     * Create a new case type
     * @param requestBody
     * @returns any Case type created successfully
     * @throws ApiError
     */
    public static a926430B1281A815885B22D745Fa4Afc(
        requestBody: {
            /**
             * Parent case type ID for sub-categories
             */
            parent_id?: number | null;
            case_type_name: string;
            is_active?: 'Yes' | 'No';
        },
    ): CancelablePromise<{
        success?: boolean;
        message?: string;
        data?: Record<string, any>;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/case-types',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthenticated`,
                422: `Validation error`,
            },
        });
    }
    /**
     * Get a specific case type
     * Retrieve details of a specific case type
     * @param id Case type ID
     * @returns any Case type details
     * @throws ApiError
     */
    public static c50D5685E67Ed5880D645099Aa5Cc06(
        id: number,
    ): CancelablePromise<{
        success?: boolean;
        data?: Record<string, any>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/case-types/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthenticated`,
                404: `Case type not found`,
            },
        });
    }
    /**
     * Update a case type
     * Update an existing case type
     * @param id Case type ID
     * @param requestBody
     * @returns any Case type updated successfully
     * @throws ApiError
     */
    public static f881459B45A830A7Fa27Badb67Cafe8C(
        id: number,
        requestBody: {
            parent_id?: number | null;
            case_type_name?: string;
            is_active?: 'Yes' | 'No';
        },
    ): CancelablePromise<{
        success?: boolean;
        message?: string;
        data?: Record<string, any>;
    }> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/case-types/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthenticated`,
                404: `Case type not found`,
                422: `Validation error`,
            },
        });
    }
    /**
     * Delete a case type
     * Delete a case type
     * @param id Case type ID
     * @returns any Case type deleted successfully
     * @throws ApiError
     */
    public static dc94Bed0A85224F2Bdee04536E8462D(
        id: number,
    ): CancelablePromise<{
        success?: boolean;
        message?: string;
    }> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/case-types/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthenticated`,
                404: `Case type not found`,
            },
        });
    }
}
